import { connect } from 'react-redux'
import { selectLanguage } from 'store/locales'
import AnniversaryArticle from '../components/ArticleVisitPage'

const mapStateToProps = ({ strings }) => {
  return {
    strings,
  }
}

const mapDispatchToProps = {
  selectLanguage,
}

export default connect(mapStateToProps, mapDispatchToProps)(AnniversaryArticle)
